<div class="white-bg surface-primary grow pr-xsmall-t mr-xsmall-b">
  @if (teaserTitle()) {
    <h2 class="flex flex--space-between mr-xsmall-b center font-headline-small">
      <span class="flex--nogrow flex--self-center bold-type nordic-blue-900-text text-icon-primary">{{
        teaserTitle()
      }}</span>
    </h2>
  }

  <div>
    <div
      class="teaserText mr-large-b font-body-medium"
      [innerHTML]="teaserText() | finEmpty: false | finSafe: 'html'"
    ></div>

    @if (target()) {
      <a
        class="link-hover inline-block ms-xsmall-x link-btn"
        [finLink]="target().url"
        [external]="target().external"
        [attr.target]="target().external ? '_blank' : ''"
      >
        @if (iconUrl()) {
          <img
            class="inline-block valign-middle"
            alt=""
            [attr.src]="iconUrl() | finSafe: 'resource'"
            [style.height.em]="2"
            [style.width]="'auto'"
          />
        }

        <span class="font-body-medium-bold">{{ target().title }}</span>
      </a>
    }
  </div>
</div>
